import React from 'react';
import { useParams } from "react-router-dom";
import { projectList } from '../helpers/projectList';
import GitHub from '@mui/icons-material/GitHub';
import '../styles/ProjectDisplay.css'

const ProjectDisplay = () => {
  const { id } = useParams();
  const project = projectList[id];
  return (
    <div className='project'>
      <h1>{project.name}</h1>
      <img src={project.secondImage} />
      <GitHub id='icon-github' />
      <div className='skills-and-description'>
        <p ><b>Skills:</b> {project.skills}</p>
        <p ><b>Short Description:</b> {project.shortDescription}</p>
      </div>
    </div>

  )
}

export default ProjectDisplay